<template>
  <div 
    class="  px-10 mt-12">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#4828a1">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status data menjadi <b class="font-weight-bold black--text">{{ message.status }}</b> ?

                <div v-if="message.status === 'tolak'">
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-6">
            Detail Pembelian
          </div>

          <v-row>
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 25px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  
                  <div>
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nama Supplier
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.supplier_name }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Kategori
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.category }}
                    </div>
                  </div>

                  <div class="mt-4" v-if="detail.status === 'terbit'">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nomor PO
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.number }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Nomor Permintaan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.permintaan_number }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Tanggal Jatuh Tempo
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.due_date | date }}
                    </div>
                  </div>

                  <div class="mt-4">
                    <div 
                      class="fs-14">
                      <!-- <span class="red--text">*</span> -->
                      Catatan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.note }}
                    </div>
                  </div>
                  

                  <!-- <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-16 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div> -->
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="!process.load && Object.keys(detail).length > 0">
            <v-col
              cols="12"
              md="12" class="pt-0">

              <div class="d-flex align-center">
                <div>
                  Data Varian
                </div>
              </div>
              <v-divider class="my-2"></v-divider>

              <v-card flat
                v-if="form.varian_arr.length < 1">
                <v-card-text
                  class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <v-img 
                      class="mx-auto"
                      contain
                      alt="vuetify"
                      :width="90"
                      :height="90"
                      :src="require('@/assets/image/empty.png')">
                      <!-- <template v-slot:placeholder>
                        <v-row
                          class=" "
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template> -->
                    </v-img>
                    <div class="mt-3 fs-18">
                      Belum Ada Varian
                    </div>
                  </div>
                </v-card-text>

                <!-- <v-card-text
                  v-else
                  class="pb-0 my-4" style="height: calc( 100vh - 350px );">
                  <v-data-table
                    v-model="form.varian_arr"
                    :headers="configHeaders"
                    :items="form.varian_arr"
                    ref="table-grid"
                    class="table-grid"
                    height="calc( 100vh - 350px )"
                    elevation="0"
                    hide-default-footer
                    :single-select="false"
                    item-key="id"
                    :items-per-page="1000000000"
                  >
                  <template
                      v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                      v-slot:[`item.${header.value}`]="{ value }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>
    
                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="Distributor Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  color="#4828a1">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>
    
                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="Distributor Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                color="#4828a1">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
    
                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="Distributor Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                color="#4828a1">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
    
                      <div v-if="header.format === 'action'">

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            
                              @click="form.varian_arr.splice(index, 1)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus</span>
                        </v-tooltip>
                      </div>
    
                      <div v-if="header.format === 'status'"
                        class="d-flex justify-start text-capitalize font-weight-medium" :class="value == 'Publish' ? 'blue--text text--darken-2' : 'red--text'">
                        {{ value }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>
                  </v-data-table>
                </v-card-text> -->
              </v-card>

              <div v-else>

                <div v-for="(item, index) in form.varian_arr" :key="index">
                  <v-card flat class="mb-5">
                    <v-card-text>
                      <div class="d-flex">
                        <div>
                          <div class="fs-16 font-weight-bold label-input">
                            {{ item.name }}
                          </div>
                          <div>
                            <span>Kode SKU</span>: <span class="font-weight-bold label-input">{{ item.sku }}</span>
                          </div>

                          <div>
                            <span>PPN</span>: <span class="font-weight-bold label-input">{{ ppn*1 }}%</span>
                          </div>
                        </div>
                      </div>

                      <v-row>
                        <v-col>
                          <div class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Unit
                          </div>

                          <div class="fs-18 label-input font-weight-bold">
                            {{ item.unit }}
                          </div>
  
                        </v-col>

                        <v-col>
                          <div class="fs-15 label-input">
                            <!-- <span class="red--text">*</span> -->
                            Qty Diterima
                          </div>

                          <div class="fs-18 label-input font-weight-bold">
                            {{ item.penerimaan_qty_terima }}
                          </div>
  
                        </v-col>

                      </v-row>

                    </v-card-text>
                  </v-card>
                </div>

                <!-- <v-divider class="my-2"></v-divider>
                <v-row>
                  <v-col cols="3">

                  </v-col>
                  <v-col cols="3">
                    
                  </v-col>
                  <v-col cols="3" class="fs-17 font-weight-bold">
                    {{ detail.grand_total | price }}
                  </v-col>
                  <v-col cols="3" class="fs-17 font-weight-bold">
                    {{ detail.grand_total_ppn | price }}
                  </v-col>
                </v-row> -->


              </div>
            </v-col>
          </v-row>



          <div v-if="message.error.length > 0"
            class="text-center my-4 d-flex align-center">
            <div
              class="error--text">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>


          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              

              <div
                v-if="detail.date_close === ''">
                <v-btn 
                  @click="dialog.status = true; message.error = ''; message.status = 'close po'"
                  :loading="process.load"
                  :disabled="process.load"
                  width="150"
                  height="45"
                  elevation="0"
                  color="#6948c6"
                  class="fs-16 white--text text-capitalize border-radius">
                  Close PO
                </v-btn>
              </div>

              
              <v-btn
                @click="$router.go(-1)"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        rejected_reason: '',
        tabs: 0,
        tab: [
          {
            title: 'Detail',

            link: `/customer/data/detail/${this.$route.params.id}?menu=detail`
          },
          {
            title: 'Toko',
            link: `/customer/data/detail/${this.$route.params.id}?menu=toko`
          },
          // {
          //   title: 'Jadwal Visit',
          //   link: `/customer/data/detail/${this.$route.params.id}?menu=visit`
          // },
          {
            title: 'Approval',
            link: `/customer/data/detail/${this.$route.params.id}?menu=approval`
          }
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        form: {
          category: '',
          supplier_id: '',
          supplier_name: '',
          due_date: '',
          note: '',
          varian_arr: []
        },
        category: [],
        branch: [],
        ppn: '',

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      Proses: () => import(/* webpackPrefetch: true */ '@/components/pembelian/proses.vue'),
      Approval: () => import(/* webpackPrefetch: true */ '@/components/customer/approval.vue'),
      Toko: () => import(/* webpackPrefetch: true */ '@/components/customer/toko.vue'),
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    watch: {
    },
    mounted () {
      this.fetchDetail()
      this.fetchConfig()
    },
    methods: {
      async fetchConfig () {
        // this.process.load = true

        let params = {
          // company_id: this.user.company_id
        }

        await get('admin/config', { params })
        .then(response => {
          let res = response.data

          // this.process.load = false
            
          if (res.status === 200) {
            // res.results.data[0].color = JSON.parse(res.results.data[0].color)

            this.ppn = res.results.data[0].ppn

            // TokenService.saveCompany(JSON.stringify(this.form))

            // this.$store.commit("setCompany", this.form)

            // if (res.results.data[0].color.length > 0) {
            //   res.results.data[0].color.map((obj) => {
            //     if (obj.active) {
            //       TokenService.saveColor(obj.hex)

            //       this.$store.commit("setColor", obj.hex)
            //     }
            //   })
            // } else {
            //   TokenService.saveColor('#DD5826')

            //   this.$store.commit("setColor", '#DD5826')
            // }

            // this.styles()
          }
        })
      },
      async fetchDetail () {
        this.detail = {}
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/pembelian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.varian_arr = []
            this.detail = res.results.data
            this.detail.detail.map((item) => {
            this.form.varian_arr.push({
              name: item.po_detail_varian_name,
              sku: item.po_detail_varian_sku,
              id: item.po_detail_varian_id,
              qty: item.po_detail_qty,
              harga_beli: item.po_detail_harga_beli,
              ppn_beli: item.po_detail_ppn_beli,
              unit: item.po_detail_varian_unit,
              penerimaan_qty_terima: item.penerimaan_qty_terima,
            })
          })
          this.detail.grand_total = this.detail.grand_total*1
          this.form.category = this.detail.category
          this.form.supplier_id = this.detail.supplier_id
          this.form.supplier_name = this.detail.supplier_name
          this.form.due_date = this.detail.due_date
          this.form.note = this.detail.note
            // this.detail.mobilephone_arr = this.detail.mobilephone_arr.length > 0 ? JSON.parse(this.detail.mobilephone_arr) : []
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'close po' ? true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true

        await post(`admin/pembelian/close`, {
          data: {
            id: this.detail.id
            // rejected_reason: this.rejected_reason
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>